import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import Box from '@mui/material/Box';

import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import CheckIcon from '@mui/icons-material/Check';
import Alert from "../../dialogs/Alert";
import LoadConfig from "../../dialogs/LoadConfig";

import modelsComplete from '../../db/models.json';



export default function Menu(props) {
	const [displayAlert, setDisplayAlert] = React.useState(false);
	const [displayAlertMsg, setDisplayAlertMsg] = React.useState("");
	const [displayConfig, setDisplayConfig] = React.useState(false);

	const { t, i18n } = useTranslation("",{lng: props.language});
	const languages = [
	  { name: t("Deutsch") ,  iso: "de" , icon: <CheckIcon sx={{fontSize: '28px', color: 'white'}}/> },
	  { name: t("English"),  iso: "en" , icon: <CheckIcon  sx={{fontSize: '28px', color: 'white'}}/>},
	];


  	let navigate = useNavigate(); 
	
	const callUrl = (url) => {
		navigate(url);
	};

	const changeLanguage = async (lng) => {
	    await i18n.changeLanguage(lng);
	    props?.setLanguage?.(lng);
	};

	const loadConfig = async (lng) => {
		setDisplayConfig(true);
		setDisplayAlertMsg("Sie müssen ein Fahrzeug auswählen");
	};

	
  	return (<>
  			{props.embedded === "true" ? (<></>) :
  	(
			<>
	   			<Alert display={displayAlert} displayAlertMsg={displayAlertMsg} setDisplayAlert={setDisplayAlert}/>
	   			<LoadConfig display={displayConfig}  setDisplayConfig={setDisplayConfig}/>

				<Box className="navbar" sx={{paddingRight: {
							xs: 0,
							sm: 0,  
							} }}>
								<div class="dropdown">
									<button class="dropbtn">
										{t("KomplettFahrzeuge")} <KeyboardArrowDownIcon/>
										<i class="fa fa-caret-down"></i>
									</button>
									<div class="dropdown-content">
										{modelsComplete.cars.map((model) => (
												<>
													{model.onlinestatus == "online" && model.compareable == "true" ? (
											        	<a onClick={e => callUrl("/model/" + model.url + "/")}>{model.producerLabel} {model.label}</a>
													):(<></>)
													}
									        	</>											
										))}
									</div>									
								</div> 
								<div class="dropdown">
									<button class="dropbtn">
										{t("Profil")} <KeyboardArrowDownIcon/>
										<i class="fa fa-caret-down"></i>
									</button>
									<div class="dropdown-content">
											<a onClick={e => loadConfig("de")}>{t("Meine Konfiguration laden")}</a>
									</div>
								</div> 
								<div class="dropdown">
									<button class="dropbtn">
										{t("Sprache")} <KeyboardArrowDownIcon/>
										<i class="fa fa-caret-down"></i>
									</button>
									<div class="dropdown-content">
										{languages.map((language) => (
											<a onClick={e => changeLanguage(language.iso)}>{language.iso == i18n.resolvedLanguage ? (<CheckIcon/>) : (<></>)}{t(language.name)}</a>
										))}
									</div>
								</div>
				</Box>
				</>
				)}
			</>
	  )
}